import React, {useEffect, useState} from "react";
import {MensajesGlobales} from "./components/mensajes/MensajesGlobales";

const SERVER_YEAR_URL = process.env.REACT_APP_SERVER_YEAR_URL;

export const Bienvenida = () => {
    const [year, setYear] = useState(() => new Date().getFullYear());

    useEffect(() => {
        if (!SERVER_YEAR_URL) {
            return;
        }
        fetch(SERVER_YEAR_URL, { method: "GET" })
            .then((res) => (res.ok ? res.json() : Promise.reject(res)))
            .then((data) => {
                if (typeof data?.year === "number") {
                    setYear(data.year);
                }
            })
            .catch(() => {
                // Mantener año del cliente si falla la petición
            });
    }, []);

    const bannerPath = `/imgs/dns-home-${year}.png`;

    return (
        <>
            <div id="content" className="fluid">
                <div className="inner-block">
                    <MensajesGlobales/>
                    <div className="box">
                        <a href="/"><img src={bannerPath} alt="bannerBienvenida" /></a>
                    </div>
                </div>
            </div>
        </>
    );
}